export default __webpack_public_path__ + "static/media/1.4ebe3a1d.png";